<template>
  <div class="scavenger-hunt-link">
    <a href="#" @click="open_scavenger_hunt_popup($event)">
      <img src="static/img/scavenger-hunt.png" alt="Scavenger Hunt" />
    </a>
  </div>
</template>

<script>
export default {
  name: "QRLink",
  methods: {
    open_scavenger_hunt_popup(e) {
      e.preventDefault();
      this.$store.dispatch("set_popup_state", "scavenger");
    }
  }
};
</script>

<style scoped>
.scavenger-hunt-link {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
}
.scavenger-hunt-link img {
  max-width: 150px;
  height: auto;
}
@media only screen and (min-width: 520px) {
  .scavenger-hunt-link img {
    max-width: 185px;
  }
}
@media only screen and (min-width: 960px) {
  .scavenger-hunt-link img {
    max-width: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/misc/QRLink.vue